import { render } from "./StatEvent.vue?vue&type=template&id=70656b1c&scoped=true"
import script from "./StatEvent.vue?vue&type=script&lang=js"
export * from "./StatEvent.vue?vue&type=script&lang=js"

import "./StatEvent.vue?vue&type=style&index=0&id=70656b1c&scoped=true&lang=css"

import exportComponent from "d:\\presta\\dev\\key4access\\key4access.front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70656b1c"]])

export default __exports__